module.exports = __webpack_public_path__ + "img/Bg_index.a903c649.jpg";